export function onlyDigits(value: string | null | undefined) {
  return (value ?? '').replace(/\D/g, '')
}

export function formatCnpj(value: string | null | undefined) {
  const raw = onlyDigits(value).slice(0, 14)
  if (raw.length <= 2) return raw
  if (raw.length <= 5) return `${raw.slice(0, 2)}.${raw.slice(2)}`
  if (raw.length <= 8) return `${raw.slice(0, 2)}.${raw.slice(2, 5)}.${raw.slice(5)}`
  if (raw.length <= 12) return `${raw.slice(0, 2)}.${raw.slice(2, 5)}.${raw.slice(5, 8)}/${raw.slice(8)}`
  return `${raw.slice(0, 2)}.${raw.slice(2, 5)}.${raw.slice(5, 8)}/${raw.slice(8, 12)}-${raw.slice(12)}`
}

export function formatDocument(value: string | null | undefined) {
  const raw = onlyDigits(value).slice(0, 14)
  const isCnpj = raw.length > 12
  if (!isCnpj) {
    if (raw.length <= 3) return raw
    if (raw.length <= 6) return `${raw.slice(0, 3)}.${raw.slice(3)}`
    if (raw.length <= 9) return `${raw.slice(0, 3)}.${raw.slice(3, 6)}.${raw.slice(6)}`
    return `${raw.slice(0, 3)}.${raw.slice(3, 6)}.${raw.slice(6, 9)}-${raw.slice(9)}`
  }
  return formatCnpj(raw)
}
